import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Nullable } from "types/types";

type SidebarState = "collapsed" | "expanded";
type AppState = {
  token?: string | null;
  clientId: string | null;
  redirectUrl: string | null;
  callback: boolean | null;
  isJustLoggedIn: boolean;
  tokenSynced?: boolean;
  initialQueryString?: string;

  sidebar: SidebarState;
  isModalVisible: boolean;
  user: Nullable<any>;
  currentPosition: any;
  currentPositions: any[];
  currentPositionPermissions: any[];
  isLoginAnimationVisible: boolean;
};

const broadcastChannel = new BroadcastChannel("tokenChannel");

const initialState: AppState = {
  token: !new URLSearchParams(window.location.search).get("logout")
    ? localStorage.getItem("token")
    : null,
  clientId: new URLSearchParams(window.location.search).get("clientid"),
  redirectUrl: new URLSearchParams(window.location.search).get("redirecturl"),
  callback:
    new URLSearchParams(window.location.search).get("callback") === "true"
      ? true
      : false,
  isJustLoggedIn: false,
  tokenSynced: false,
  initialQueryString: window.location.search,

  sidebar: "expanded",
  isModalVisible: false,
  user: null,
  currentPosition: {},
  currentPositions: [],
  currentPositionPermissions: [],
  isLoginAnimationVisible: false,
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<any>) => {
      localStorage.setItem("token", action.payload.access_token);
      localStorage.setItem("refresh_token", action.payload.refresh_token);
      state.token = action.payload;

      broadcastChannel.postMessage({
        type: "tokenUpdate",
        data: {
          access_token: action.payload.access_token,
          refresh_token: action.payload.refresh_token,
        },
      });
    },
    clearToken: (state) => {
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      state.token = null;

      broadcastChannel.postMessage({
        type: "tokenClear",
      });
    },
    syncToken: (state, action: PayloadAction<any>) => {
      action.payload && action.payload.access_token
        ? localStorage.setItem("token", action.payload.access_token)
        : localStorage.removeItem("token");
      action.payload.refresh_token
        ? localStorage.setItem("refresh_token", action.payload.refresh_token)
        : localStorage.removeItem("refresh_token");

      state.token = action.payload ? action.payload.access_token : null;
      state.tokenSynced = true;
    },
    reloadToken: (state) => {
      state.token = localStorage.getItem("token");
    },
    setSidebar: (state, action: PayloadAction<SidebarState>) => {
      state.sidebar = action.payload;
    },
    setIsModalVisible: (state, action: PayloadAction<boolean>) => {
      state.isModalVisible = action.payload;
    },
    setUser: (state, action: PayloadAction<any>) => {
      state.user = action.payload;
    },
    setCurrentPosition: (state, action: PayloadAction<any>) => {
      state.currentPosition = action.payload;
    },
    setCurrentPositions: (state, action: PayloadAction<any[]>) => {
      state.currentPositions = action.payload;
    },
    setCurrentPositionPermissions: (state, action: PayloadAction<any[]>) => {
      state.currentPositionPermissions = action.payload;
    },
    setIsJustedloggedIn: (state, action: PayloadAction<boolean>) => {
      state.isJustLoggedIn = action.payload;
    },
    setIsLoginAnimationVisible: (state, action: PayloadAction<boolean>) => {
      const isIframe = window.self !== window.top;

      if (!isIframe) {
        state.isLoginAnimationVisible = action.payload;
      }
    },
  },
});

export const {
  setToken,
  clearToken,
  syncToken,
  reloadToken,
  setIsJustedloggedIn,
  setSidebar,
  setIsModalVisible,
  setUser,
  setCurrentPosition,
  setCurrentPositions,
  setCurrentPositionPermissions,
  setIsLoginAnimationVisible,
} = appSlice.actions;
export default appSlice.reducer;
